import axios from "axios";
import {hostWithPrefix} from "../Constructor/common/ApiCommon";

export function getAll(filters, sort, asc) {
    let qs = getQueryString(filters)
    if (sort !== undefined) {
        qs += "&sort=" + sort + "&asc=" + asc
    }
    return axios({
        url: 'http://' + hostWithPrefix + '/api/outputforms' + qs,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    })
}

export function deleteOutputFormById(id) {
    return axios({
        url: 'http://' + hostWithPrefix + '/api/outputforms/' + id,
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
        }
    })
}

export function deleteOutputFormsByIds(ids) {
    return axios({
        url: 'http://' + hostWithPrefix + '/api/outputforms',
        method: 'DELETE',
        data: ids,
        headers: {
            'Content-Type': 'application/json',
        }
    })
}

export function downloadOutputFormFileById(id) {
    return axios({
        url: 'http://' + hostWithPrefix + '/api/outputforms/' + id + '/download',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        responseType: 'blob', // important
    })
}

export function downloadOutputFormsFiles(ids) {
    return axios({
        url: 'http://' + hostWithPrefix + '/api/outputforms/download',
        method: 'POST',
        data: ids,
        responseType: 'blob', // important
    })
}

export function getQueryString(filters) {
    let str = "?"

    for (let entry of filters) {
        str += entry[0] + "=" + entry[1] + "&";
    }

    return str
}